import { LinkedInIcon, DribbbleIcon, BehanceIcon } from "../Icons";
import { useSettings } from "../../data/content";

// Icons stay in code and are matched on the label — the CMS holds the URLs, not
// the artwork. A label with no matching icon is skipped rather than rendered bare.
const ICONS = {
  LinkedIn: LinkedInIcon,
  Dribbble: DribbbleIcon,
  Behance: BehanceIcon,
};

function FooterSocials() {
  const { socials = [] } = useSettings();

  return (
    <div className="flex items-center gap-5">
      {socials.map(({ _key, label, href }) => {
        const Icon = ICONS[label];
        if (!Icon) return null;

        return (
          <a
            key={_key}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            className="text-text-muted-light dark:text-text-muted-dark hover:text-text-primary-light dark:hover:text-text-primary-dark transition-colors duration-200"
          >
            <Icon />
          </a>
        );
      })}
    </div>
  );
}

export default FooterSocials;
